/**
 * @export
 * @class DealDescription
 * 상품정보 / 배송/환불정보 / 기타등등..!
 */
export default class DealDescription {
  constructor() {
    // 필요 data 유효 확인
    const {
      deliveryInfo,
      categoryInfo,
      dealType,
      ticketStartDate,
      ticketEndDate,
      ticketInfo,
    } = TMON.oApp.htStorage.htStaticData.htDealInfo;
    const {
      contentInfo = {},
    } = TMON.oApp.htStorage.htStaticData.htDealContentInfo;
    if (
      !deliveryInfo &&
      Object.keys(deliveryInfo).length < 1 &&
      !categoryInfo &&
      Object.keys(categoryInfo).length < 1 &&
      !contentInfo &&
      Object.keys(contentInfo).length < 1
    )
      return;
    /* delivery 정보 */
    this.deliveryInfo = deliveryInfo;
    /* category 정보 */
    this.categoryInfo = categoryInfo;
    /* content 정보 */
    this.contentInfo = contentInfo;
    /* 티켓 유효 기간 시작일 */
    this.ticketStartDate = ticketStartDate.split(" ")[0];
    /* 티켓 유효 기간 마지막 */
    this.ticketEndDate = ticketEndDate.split(" ")[0];
    /* 티켓 유효기간 노출 여부 */
    this.viewTicketValidDate = this.contentInfo.viewTicketValidDate;

    this.ticketInfo = ticketInfo;

    this.dealType = dealType;

    this.welWrapper = $("#_wrapDealDescription");

    this.setEvent();
    this.render();
  }

  setEvent() {
    // toggle eventListener 등록
    this.welWrapper.on("click", "[data-role=toggleButton]", this.onClickToggle);

    // 앱에서 링크 이동 eventListener 등록
    if (TMON.view_mode === "app") {
      this.welWrapper.on("click", "a", this.onClickLink);
    }
  }

  clearEvent() {
    if (this.welWrapper) {
      this.welWrapper.off("click", "[data-role=toggleButton]");
      if (TMON.view_mode === "app") {
        this.welWrapper.off("click", "a");
      }
    }
  }

  /**
   * toggle eventListener
   */
  onClickToggle = (e) => {
    $(e.currentTarget).toggleClass("open");
  };

  /**
   * 앱에서 링크 이동 eventListener
   */
  onClickLink = (e) => {
    TMON.app.callApp(
      "webview",
      "showNaviWebView",
      "티몬",
      TMON.util.aup($(e.currentTarget).attr("href"), TMON.sAppQuery),
      false,
      false,
      true
    );

    e.preventDefault();
  };

  render() {
    const sHtml = this.drawValidTicketInfo() + this.drawDealInfo();
    this.welWrapper.html(sHtml);
  }

  /**
   * oldTicketValidDate 조건
   *
   * 1.티켓딜에서 옵션,단품일 경우 Admin에서 date를 수기로 직접 입력하지 않고 체크박스로 선택 후 DB에 저장하면 ticketStartDate 생성 (최초 생성시)
   *
   * 2.데이트가 변경되면 ticketStartDate,ticketEndDate에 추가 그 전 날짜는 oldTicketValidDate에 저장
   *
   * 3.변경이 되었다면 userInfoDesc는 현재 날짜->변경된 날짜로 문구를 보여준다.
   * ex) 2021.05.07 ~ 2021.07.05 > 2023.05.06 ~ 2023.07.07
   */
  drawValidTicketInfo() {
    if (
      this.viewTicketValidDate &&
      this.dealType === "TICKET" &&
      (this.ticketInfo.diffExpireType === "DEAL" ||
        this.ticketInfo.diffExpireType === "OPTION")
    ) {
      const { oldTicketValidDate } = this.contentInfo;
      let useInfoDesc = "";
      if (oldTicketValidDate) {
        /* 현재 티켓 유효기간 */
        useInfoDesc = `<p>${oldTicketValidDate}&nbsp;&nbsp;>&nbsp;&nbsp;${
          this.ticketStartDate
        } ~ ${this.ticketEndDate}&nbsp;변경되었습니다.`;
      } else {
        useInfoDesc = `<p>${this.ticketStartDate} ~ ${this.ticketEndDate}</p>`;
      }
      const sHtml = this.drawDealDescription({
        infoTitle: "티켓 유효기간",
        oepnClass: "",
        stateSection: "block",
        useInfoDesc: `${useInfoDesc}`,
      });
      return sHtml;
    }
    return "";
  }

  drawDealInfo() {
    const { verticalType = { verticalType: false } } = this.categoryInfo;

    const descKey = Object.keys(this.contentInfo)
      .filter((key) => key.indexOf("useInfoTitle") > -1)
      .sort();

    const sHtml = descKey
      .map((item, idx) => {
        /* InfoTitle (ex.티켓 사용 방법) */
        const infoTitle =
          this.contentInfo[item] &&
          this.contentInfo[item].replace(/\\;(\d+)?/g, "");
        // "useInfoTitle${idx}: 티켓 사용 정보\;00\;0" 와 같이 admin에서 입력한 color코드가 포함되어있어 제거한다.

        // MW, APP 첫번째 영역만 open 하고 나머지는 기본 닫힘 상태
        const openClass = idx === 0 ? "open" : "";

        const useInfoDesc = this.contentInfo[`useInfoDesc${idx + 1}`];

        /* Content 설명이 없으면 none 있으면 block */
        const stateSection = !useInfoDesc ? "none" : "block";
        if (infoTitle !== "") {
          // contentInfo[`useInfoDesc${idx + 1}`]은 6번까지 있고 NULL로 들어올 수 있음
          return this.drawDealDescription({
            infoTitle,
            openClass,
            stateSection,
            useInfoDesc,
            verticalType,
          });
        }
        return "";
      })
      .join("");
    return sHtml;
  }

  drawDealDescription({ infoTitle, openClass, stateSection, useInfoDesc }) {
    return `<div class="bx_ct" style="display:${stateSection}">
              <div class="ct_wrp">
                  <button type="button" data-role="toggleButton" class="toggle tit_align_top ${openClass}">
                      <h4>${infoTitle}</h4>
                  </button>
                  <div class="ct slide-ct">
                      <div class="lst_plain">
                          <div>${useInfoDesc}</div>
                      </div>
                  </div>
              </div>
            </div>`;
  }
}
